import { render, staticRenderFns } from "./CustomerFormTemplateQuestionOption.vue?vue&type=template&id=38b6d742&"
import script from "./CustomerFormTemplateQuestionOption.vue?vue&type=script&lang=js&"
export * from "./CustomerFormTemplateQuestionOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports